import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import {About} from "./About";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <div>
      <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
        </ul>
      </nav>
    </div>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="about" element={<About />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
